import Swal from 'sweetalert2';

// Share (or copy) a link to a specific item's detail page from a listing card.
// On listing pages window.location.href points at the listing, not the item, so
// we build an absolute URL to the item's own hash route. Uses the native share
// sheet when available, otherwise copies to clipboard.
// Added for the 2026-06-11 client fix (listing-card share not working).
export const shareItem = (e, path, title = 'CarsAvenue') => {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  // hash-router app: origin + pathname + "#/route"
  const base = `${window.location.origin}${window.location.pathname}`;
  const cleanPath = String(path || '');
  const hash = cleanPath.startsWith('#')
    ? cleanPath
    : `#${cleanPath.startsWith('/') ? '' : '/'}${cleanPath}`;
  const url = `${base}${hash}`;

  if (navigator.share) {
    navigator.share({ title, url }).catch(() => {});
  } else if (navigator.clipboard) {
    navigator.clipboard
      .writeText(url)
      .then(() =>
        Swal.fire({
          title: 'Link copied to clipboard',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
        })
      )
      .catch(() => Swal.fire({ title: 'Copy this link', text: url, icon: 'info' }));
  } else {
    Swal.fire({ title: 'Copy this link', text: url, icon: 'info' });
  }
};
